<template>
  <div>
    <ClientsList/>
  </div>
</template>

<script>
import ClientsList from './clients/ClientsList.vue';

export default {
  name: 'HomeView',

  components: { ClientsList },
  
}
</script>
